module.exports = __webpack_public_path__ + "static/media/mst_g3.f5c94585.png";